import { useQuery } from '@tanstack/react-query';
import api from '@/services/api';

export type BrokerInsuranceCompany = {
  id: string;
  name: string;
  code: string;
  short_name?: string;
  logo_url?: string;
};

/**
 * Returns the active insurance companies for the current broker user.
 *
 * Resolution is done on the backend via BrokerUser membership (falls back to
 * user.tenant_id) so a stale tenant_id on the user record cannot silently
 * return the wrong broker's insurer list.
 */
export function useBrokerInsuranceCompanies(_brokerId?: string | undefined) {
  return useQuery<BrokerInsuranceCompany[]>({
    queryKey: ['broker-insurance-companies', 'me'],
    queryFn: async () => {
      const response = await api.get('/brokers/my-insurance-companies/');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
